<template>
    <div class="main-wrapper">
       <div class="wrapper">
       <form action="">
          <h1>Forgot Password</h1>
          <div class="text-xs mb-6 font-bold">
            Enter your registered email address and we’ll <br/>
            send you a link to reset your password.
          </div>
          <div class="input-box">
             <input type="email" placeholder="Email" required>
            
          </div>
          <router-link  to="/reset-password">
          <button type="submit" class="btn">Submit</button>
          </router-link>
          <div class="register-link">
             <p>Don't have an account? <a href="#">
                Register
             </a></p>
          </div>
       </form>
    </div>
    </div>
 </template>
 
 <script>
 
 </script>
 
 <style></style>